export default "<ion-app>\n  <ion-router-outlet id=\"main-content\"></ion-router-outlet>\n</ion-app>\n";